import React, { Component } from 'react';
import { DataTypeMandat, IDS_TYPE_MANDAT } from '../../data/DataTypeMandat.jsx';
import { EUIComboBox } from '../EUI/EUIComboBox';

// KP - 2550 - 10/10/2023 : masquer les types de mandats administrateur + maison individuelle + module externe + contrôle de gestion national (accessibles uniquement aux admins)
// KP - 2550 - 17/10/2023 : ajout call center
export class ComboBoxTypeMandat extends Component {

    static defaultProps = {
        idTypeMandat: undefined,
        inclureAdministrateur: false,
        inclureCallCenter: false,
        inclureCommercialisateur: true,
        inclureControleDeGestionNational: false,
        inclureEbook: false,
        inclureMaisonIndividuelle: false,
        inclureModuleExterne: false,
        inclurePrimPromo: false,
        inclureWebServices: false,
        label: "Type de mandat",
        placeholder: "Type de mandat",
    };

    render = () => {

        // Si idTypeMandat === null alors charger tous les TypeMandat
        // Si idTypeMandat === IdTypeMandat.Commercialisateur || IdTypeMandat.WebServices alors charger TypeMandat correspondant
        // Si idTypeMandat === 0 alors charger tous les TypeMandat sauf IdTypeMandat.Commercialisateur et IdTypeMandat.WebServices
        // Si idTypeMandat === -1 alors charger tous les TypeMandat sauf IdTypeMandat.WebServices
        // KP - 2550 - 09/10/2023 : les valeurs 0 et -1 ont été remplacées ; on passe désormais une liste d'ids à exclure

        const { idTypeMandat, inclureAdministrateur, inclureCallCenter, inclureCommercialisateur, inclureControleDeGestionNational, inclureEbook, inclureMaisonIndividuelle, inclureModuleExterne, inclurePrimPromo, inclureWebServices } = this.props;
        const { ADMINISTRATEUR, CALLCENTER, COMMERCIALISATEUR, CONTROLEGESTIONNATIONAL, EBOOK, MAISON_INDIVIDUELLE, MODULEEXTERNE, PRIMPROMO, WEB_SERVICES } = IDS_TYPE_MANDAT;

        let listTypeMandatAExclure = [];
        if (!inclureAdministrateur) listTypeMandatAExclure.push(ADMINISTRATEUR);
        if (!inclureCallCenter) listTypeMandatAExclure.push(CALLCENTER);
        if (!inclureCommercialisateur) listTypeMandatAExclure.push(COMMERCIALISATEUR);
        if (!inclureControleDeGestionNational) listTypeMandatAExclure.push(CONTROLEGESTIONNATIONAL);
        if (!inclureEbook) listTypeMandatAExclure.push(EBOOK);
        if (!inclureMaisonIndividuelle) listTypeMandatAExclure.push(MAISON_INDIVIDUELLE);
        if (!inclureModuleExterne) listTypeMandatAExclure.push(MODULEEXTERNE);
        if (!inclurePrimPromo) listTypeMandatAExclure.push(PRIMPROMO);
        if (!inclureWebServices) listTypeMandatAExclure.push(WEB_SERVICES);
        if (!inclureWebServices) listTypeMandatAExclure.push(WEB_SERVICES);

        const fetchMethod = () => DataTypeMandat._chargementTypeMandat(idTypeMandat, listTypeMandatAExclure);

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            itemKey={item => item.idTypeMandat}
            itemText={item => item.typeMandat}
            stamp={[idTypeMandat, listTypeMandatAExclure]}
        />;

    };

};